import { render, staticRenderFns } from "./DrugOrderItemsRelocation.vue?vue&type=template&id=35f146a0&"
import script from "./DrugOrderItemsRelocation.vue?vue&type=script&lang=js&"
export * from "./DrugOrderItemsRelocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports